export default "__VITE_ASSET__BBfR1Glt__"